module.exports = __webpack_public_path__ + "static/Report_Outage_Home_New-747c246949bc1b4c3453751251d811d9.png";